// Interface

import util from '@/utils/classToObject'
import { IUniteMobileState } from './state'
import { AloDbUniteMobile } from '@/models/alodb/AloDbUniteMobile'

export class UniteMobileGetter {  
      
  public uniteMobiles(state:IUniteMobileState,getters:any) {
    return state.uniteMobiles
  }

  public modifiedAdmUniteMobile(state:IUniteMobileState,getters:any) {
    return state.modifiedAdmUniteMobile
  }

  public originalAdmUniteMobile(state:IUniteMobileState,getters:any) {
    return state.originalAdmUniteMobile
  }

  public uniteMobileLoading(state:IUniteMobileState,getters:any) {
    return state.uniteMobileLoading
  }

  public uniteMobilesById(state:IUniteMobileState) {     
    return state.uniteMobiles.reduce((acc,value) =>{
        acc[value.UMB_ID!] = value
        return acc
    },{}  as {[id:number]:AloDbUniteMobile})      
  }

  public uniteMobileStatus(state:IUniteMobileState) {     
    return state.status
  }

  public adminUniteMobileFilter(state:IUniteMobileState) {     
    return state.adminFilter
  }
  
}

export default util.classToObject(UniteMobileGetter)